/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { Component } from "react"
import * as Icon from "react-feather"

class EventFilterItemOption extends Component {
  state = {
    selected: this.props.defaultSelected || false,
  }

  componentDidUpdate = () => {
    const { selected } = this.state

    if (this.props.clear && selected) {
      return this.clear()
    }
  }

  select = () => {
    this.props.optionSelect()
    const { selected } = this.state

    this.setState({
      selected: !selected,
    })
  }

  clear = () => {
    this.setState({ selected: false })
  }

  render() {
    const { selected } = this.state

    return (
      <div className="event-filter__item-option">
        <p
          className={`event-filter__item-option-title ${
            selected ? "event-filter__item-option-title--selected" : ""
          }`}
        >
          {this.props.title}
        </p>
        <input
          onClick={this.select}
          className="event-filter__item-option-input"
          type="checkbox"
          name={this.props.title}
          value={this.props.value}
          onChange={this.props.onSelect}
        />
        {selected && (
          <Icon.Check className="event-filter__item-option-check icon icon--sm" />
        )}
      </div>
    )
  }
}

EventFilterItemOption.defaultProps = {
  title: "",
}

export default EventFilterItemOption
